<script lang="ts">import { setContext } from 'svelte';
import { createCarouselStore } from '../store';
const { children } = $props();
const { emblaApi, canScrollPrev, canScrollNext } = createCarouselStore();
setContext('carousel', { emblaApi, canScrollPrev, canScrollNext });
</script>

{@render children?.()}
